import Paper from '@mui/material/Paper';
import { makeStyles } from 'tss-react/mui';
import { getCoverImageUrls } from '../utils';
import { useState, MouseEvent } from 'react';
import { CardHeader, CardImage, CardDetails, CardActions } from './components';
import { ICollection, IActionItem } from '../../../../common/interfaces';

const useStyles = makeStyles()((theme) => ({
	collectionContainer: {
		width: '275px',
		minWidth: '275px',
		margin: theme.spacing(1),
	},
}));

interface IProps {
	collection: ICollection;
}

const CollectionCard = ({ collection }: IProps) => {
	let actionItems: IActionItem[] = [];
	const { classes } = useStyles();
	const { name, techPacks } = collection;
	const [anchorMenuEl, setMenuAnchorEl] = useState<null | HTMLElement>(null);
	const menuOpen = Boolean(anchorMenuEl);

	const handleMenuClick = (event: MouseEvent<HTMLElement>) => {
		event.preventDefault();
		event.stopPropagation();

		if (menuOpen) {
			setMenuAnchorEl(null);
		} else {
			setMenuAnchorEl(event.currentTarget);
		}
	};

	const coverImageUrls = getCoverImageUrls({ techPacks });

	if (!collection.isReady) {
		actionItems = [
			{
				id: 1,
				action: 'Some action item',
			},
			{
				id: 2,
				action: 'Some action item',
			},
			{
				id: 3,
				action: 'Some action item',
			},
		];
	}

	return (
		<Paper elevation={2} className={classes.collectionContainer}>
			<CardHeader
				title={name}
				menuOpen={menuOpen}
				anchorMenuEl={anchorMenuEl}
				handleMenuClick={handleMenuClick}
			/>
			<CardImage coverImageUrls={coverImageUrls} />
			<CardDetails
				collection={collection}
				actionItemCount={actionItems.length}
			/>
			<CardActions actionItems={actionItems} />
		</Paper>
	);
};

export default CollectionCard;
